import { Button, useDisclosure } from '@ritualco/jutsu'
import { ReactComponent as SettingsIcon } from 'assets/Icons/Settings.svg'
import {
  EditableSection,
  EditableSectionTerm,
  EditableSectionTermRow,
  EditableSectionValue,
} from 'components/EditableSection'
import { IncentiveEmployeesModal } from 'components/Modals/IncentiveEmployeesModal'
import { useContent } from 'lib/content/react'
import { selectOrganizationType } from 'state/selectors/organization'
import { useStore } from 'state/store'
import { IncentiveRecipients } from 'types/entities'
import { IncentiveRecipientsOnSubmit } from 'views/Incentive/types'

interface RecipientsSectionProps {
  recipients?: IncentiveRecipients
  organizationId: string
  workspaceId: string
  onSubmit: IncentiveRecipientsOnSubmit
}
export const RecipientsSection = ({
  recipients,
  organizationId,
  workspaceId,
  onSubmit,
}: RecipientsSectionProps) => {
  const organizationType = useStore(selectOrganizationType)
  const { formatMessage } = useContent()
  const {
    isOpen: isEmployeesOpen,
    onOpen: onEmployeesOpen,
    onClose: onEmployeesClose,
  } = useDisclosure()

  return (
    <EditableSection
      title={formatMessage({ id: 'pmportal.incentives.whoCanAccess' })}
      action={
        <Button
          colorScheme="transparent"
          variant="outline"
          leftIcon={<SettingsIcon style={{ height: 18, width: 18 }} />}
          onClick={() => {
            if (organizationType === 'COMPANY') {
              onEmployeesOpen()
            }
          }}
        >
          {formatMessage({ id: 'pmportal.global.actionManage' })}
        </Button>
      }
    >
      {organizationType === 'PROPERTY_MANAGER' && (
        <>
          <EditableSectionTermRow>
            <EditableSectionTerm>
              {formatMessage({ id: 'pmportal.incentives.companies' })}
            </EditableSectionTerm>
            <EditableSectionValue>
              {recipients?.allCompanies
                ? formatMessage({ id: 'pmportal.incentives.allCompanies' })
                : formatMessage(
                    { id: 'pmportal.incentives.companiesCount' },
                    { count: recipients?.companies.length || 0 }
                  )}
            </EditableSectionValue>
          </EditableSectionTermRow>
          <EditableSectionTermRow>
            <EditableSectionTerm>
              {formatMessage({ id: 'pmportal.incentives.people' })}
            </EditableSectionTerm>
            <EditableSectionValue>
              {recipients?.allPeople
                ? formatMessage({ id: 'pmportal.incentives.allPeople' })
                : formatMessage(
                    { id: 'pmportal.incentives.peopleCount' },
                    { count: recipients?.people.length || 0 }
                  )}
            </EditableSectionValue>
          </EditableSectionTermRow>
        </>
      )}
      {organizationType === 'COMPANY' && (
        <>
          <EditableSectionTermRow>
            <EditableSectionTerm>
              {formatMessage({ id: 'pmportal.incentives.employees' })}
            </EditableSectionTerm>
            <EditableSectionValue>
              {recipients?.allPeople
                ? formatMessage({ id: 'pmportal.incentives.allEmployees' })
                : formatMessage(
                    { id: 'pmportal.incentives.employeesCount' },
                    { count: recipients?.people.length || 0 }
                  )}
            </EditableSectionValue>
          </EditableSectionTermRow>
          <IncentiveEmployeesModal
            isOpen={isEmployeesOpen}
            onClose={onEmployeesClose}
            organizationId={organizationId}
            workspaceId={workspaceId}
            recipients={recipients}
            onSubmit={onSubmit}
          />
        </>
      )}
    </EditableSection>
  )
}
